import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  Modal,
  Menu,
  MenuItem,
  TextField,
  Button,
  IconButton,
  Select,
  FormControl,
  InputLabel,
  Input,
  CircularProgress,
  TablePagination,
} from "@mui/material";
import { MoreVert } from "@mui/icons-material";

import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useDelete, useUpdate } from "../../hooks";

import SnackbarComponent from "../../components/SnackBar/snackBar";

export default function AdminSubcategory() {
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    severity: "success", // Default severity
    message: "",
    position: { vertical: "top", horizontal: "center" },
  });
  const loginToken = useSelector((state) => state.user.logintoken);
  console.log("subcat token", loginToken);

  const [vendors, setVendors] = useState();

  const [categories, setCategories] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isCategoryModal, setCategoryModal] = useState(true);
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [categoryNameError, setCategoryNameError] = useState("");
  const [subCategoryNameError, setSubCategoryNameError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
const [imageError, setImageError] = useState("");
  const getInitialFormValues = () => ({
    category_id: selectedVendor ? selectedVendor.category_id : "",
    name: selectedVendor ? selectedVendor.name : "",
    subCategory_id: selectedVendor ? selectedVendor.subCategory_id : "",
    subCategory_name: selectedVendor ? selectedVendor.subCategory_name : "",
    description: selectedVendor ? selectedVendor.description : "",
    image: selectedVendor ? selectedVendor.image_url : "",
    status: selectedVendor ? selectedVendor.status : "",
  });
  const [formValues, setFormValues] = useState(getInitialFormValues());

  const {
    data: subCategoryData,
    isLoading: isSubCategoriedLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllSubCategories"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: categoryData,
    error: categoryDataError,
    fetchData: fetchCategoryData,
  } = useFetch(BASE_URL_TEST + urls("getAllCategories"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    fetchData();
    fetchCategoryData();
  }, []);

  useEffect(() => {
    if (error) {
    } else if (subCategoryData && subCategoryData["status"] === true) {
      console.log("subCategoryData", subCategoryData["data"]);
      setVendors(subCategoryData["data"]);
    }
  }, [subCategoryData, error]);

  useEffect(() => {
    if (categoryDataError) {
    } else if (categoryData && categoryData["status"] === true) {
      console.log("categoryData", categoryData["data"]);
      setCategories(categoryData["data"]);
    }
  }, [categoryData, categoryDataError]);

  const {
    data: updatedSubCategoryData,
    error: updatedSubCategoryError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    if (updatedSubCategoryError) {
    } else if (
      updatedSubCategoryData &&
      updatedSubCategoryData["status"] === true
    ) {
      console.log("updatedCategoryData", updatedSubCategoryData["data"]);

      setSnackbarState({
        ...snackbarState,
        open: true,
        message: updatedSubCategoryData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      fetchData();
    }
  }, [updatedSubCategoryData, updatedSubCategoryError]);

  const {
    data: deletedSubCategoryData,
    error: deletedSubCategoryError,
    deleteData: fetchDeleteData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    if (deletedSubCategoryError) {
    } else if (
      deletedSubCategoryData &&
      deletedSubCategoryData["status"] === true
    ) {
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: deletedSubCategoryData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      handleMenuClose();
      fetchData();
    }
  }, [deletedSubCategoryData, deletedSubCategoryError]);

  const {
    data: createSubCategoryData,
    isLoading: createSubCategoryLoading,
    error: createSubCategoryError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createSubCategories"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
useEffect(() => {
  if (createSubCategoryData) {

    setSnackbarState({
      open: true,
      message: createSubCategoryData.message,
      position: {
        vertical: "top",
        horizontal: "center",
      },
      severity: createSubCategoryData.status
        ? "success"
        : "error",
    });

    if (createSubCategoryData.status) {
      setModalOpen(false);
       setFormValues({
        category_id: "",
        description: "",
        image: "",
        name: "",
        status: "",
        subCategory_id: "",
        subCategory_name: "",
      });

      setSelectedVendor(null);
      fetchData();
    }
  }
}, [createSubCategoryData]);
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Handle search
  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  const filteredData = search
    ? vendors.filter(
        (item) =>
          item.name.toLowerCase().includes(search.toLowerCase()) ||
          item.description.toLowerCase().includes(search.toLowerCase()),
      )
    : vendors;
  const handleMenuClick = (event, vendor) => {
    setAnchorEl(event.currentTarget);
    console.log("hanldemenyclick", vendor);
    setSelectedVendor(vendor);
    setFormValues({
      category_id: vendor.category_id || "",
      subCategory_id: vendor.sub_cat_id || "",
      subCategory_name: vendor.name || "",
      name: vendor.category_name || "",

      description: vendor.description || "",

      image: vendor.image_url || null, // Assuming 'imageurl' holds the image
      status: vendor.status !== undefined ? vendor.status : 1, // Ensure status is set
    });
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedVendor(null);
  };

  const handleDelete = () => {
    // setVendors(vendors.filter((v) => v.sno !== selectedVendor.sno));
    // handleMenuClose();

    const deleteUrl = urls("deleteSubCategories", selectedVendor["sub_cat_id"]);
    fetchDeleteData(deleteUrl);
  };

  const handleAddSubCategory = () => {
  setCategoryNameError("");
  setSubCategoryNameError("");
  setDescriptionError("");
  setImageError("");

  let hasError = false;

  if (!formValues.category_id) {
    setCategoryNameError("Category is required");
    hasError = true;
  }

  if (!formValues.subCategory_name?.trim()) {
    setSubCategoryNameError("Sub category name is required");
    hasError = true;
  }

  if (!formValues.description?.trim()) {
    setDescriptionError("Description is required");
    hasError = true;
  }

  if (!formValues.image) {
    setImageError("Image is required");
    hasError = true;
  }

  if (hasError) {
    return;
  }

  const formdata = new FormData();
  formdata.append("name", formValues.subCategory_name);
  formdata.append("category_id", formValues.category_id);
  formdata.append("description", formValues.description);
  formdata.append("imageurl", formValues.image);

  fetchCreateData(formdata);
};
const resetForm = () => {
  setFormValues({
    category_id: "",
    description: "",
    image: "",
    name: "",
    status: "",
    subCategory_id: "",
    subCategory_name: "",
  });

  setSelectedVendor(null);

  setCategoryNameError("");
  setSubCategoryNameError("");
  setDescriptionError("");
  setImageError("");
};
  const handleEdit = () => {
    const formdata = new FormData();
    formdata.append("name", formValues["subCategory_name"]);
    formdata.append("category_id", formValues["category_id"]);

    formdata.append("description", formValues["description"]);

    formdata.append("imageurl", formValues["image"]);
    formdata.append("status", formValues["status"]);
    console.log("selectedvdnro edit", formValues);

    const updateUrl = urls("updateSubCategories", formValues["subCategory_id"]);
    fetchUpdateData(updateUrl, formdata);

    setModalOpen(false);
    handleMenuClose();
    setFormValues({
      category_id: "",
      description: "",
      image: "",
      name: "",
      status: "",
      subCategory_id: "",
      subCategory_name: "",
    });
  };

 const handleFileChange = (e) => {
  const file = e.target.files[0];

  setFormValues({
    ...formValues,
    image: file,
  });

  if (file) {
    setImageError("");
  }
};

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log("formvalues dropdown", name, value);

    const nameToFormKey = {
      subcategory: "sub_cat_id",
      category: "category_id",
    };
    const formKey = nameToFormKey[name] || name;

    setFormValues((prevValues) => {
      const newValues = {
        ...prevValues,
        [formKey]: value,
      };
      return newValues;
    });
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setFormValues({
      category_id: "",
      description: "",
      image: "",
      name: "",
      status: "",
      subCategory_id: "",
      subCategory_name: "",
    });
    setSelectedVendor(null);
  };

  const handleSnackbarClose = () => {
    setSnackbarState((prev) => ({ ...prev, open: false }));
  };

  return (
    <Box sx={{ padding: 3, backgroundColor: "#F9FAFC" }}>
      {/* Buttons */}

      <SnackbarComponent
        open={snackbarState.open}
        onClose={handleSnackbarClose}
        severity={snackbarState.severity}
        message={snackbarState.message}
        position={snackbarState.position}
      />

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          borderRadius: "20px",
        }}
      >
        <TextField
          variant="outlined"
          placeholder="Search"
          size="small"
          value={search}
          onChange={handleSearch}
          sx={{
            width: "30%",
            backgroundColor: "#FFF",
            borderRadius: 1,
          }}
        />
        {/* <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setCategoryModal(true);
            setModalOpen(true);
          }}
          sx={{
            backgroundColor: "#28A745",
            "&:hover": { backgroundColor: "#218838" },
            textTransform: "none",
            fontWeight: "bold",
          }}
        >
          Add Category
        </Button> */}
        <Button
          variant="contained"
          color="primary"
         onClick={() => {
  resetForm();
  setCategoryModal(false);
  setModalOpen(true);
}}
          sx={{
            backgroundColor: "#007BFF",
            "&:hover": { backgroundColor: "#0056b3" },
            textTransform: "none",
            fontWeight: "bold",
          }}
        >
          Add Sub Category
        </Button>
      </Box>

      <Box>
        {isSubCategoriedLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <CircularProgress />
          </Box>
        ) : null}
      </Box>

      {/* Vendor Table */}
      <TableContainer
        component={Paper}
        sx={{ borderRadius: "20px", p: 0, borderRadius: 2, boxShadow: 2 }}
      >
        <Table>
          <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>S.no</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Category</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Sub Category</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Image</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Description</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData && filteredData.length > 0 ? (
              filteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((vendor) => (
                  <TableRow key={vendor.sub_cat_id}>
                    <TableCell>{vendor.sub_cat_id}</TableCell>
                    <TableCell>
                      {/* {Array.isArray(vendor.category)
                    ? vendor.category.join(", ")
                    : vendor.category} */}
                      {vendor.category_name}
                    </TableCell>
                    <TableCell>{vendor.name}</TableCell>
                    <TableCell>
                      {vendor.image_url ? (
                        <img
                          src={vendor.image_url}
                          alt="Category"
                          style={{ width: 50, height: 50, objectFit: "cover" }}
                        />
                      ) : (
                        <Typography>{vendor.image}</Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      <Typography
                        color={vendor.status === 1 ? "green" : "gray"}
                        fontWeight={"bold"}
                      >
                        {vendor.status === 1 ? "Active" : "InActive"}
                      </Typography>
                    </TableCell>
                    <TableCell>{vendor.description}</TableCell>
                    <TableCell>
                      <IconButton onClick={(e) => handleMenuClick(e, vendor)}>
                        <MoreVert />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                       open={Boolean(anchorEl) && selectedVendor?.sub_cat_id === vendor.sub_cat_id}
                        onClose={handleMenuClose}
                      >
                        <MenuItem
                          onClick={() => {
                            setFormValues({
                              category_id: selectedVendor.category_id,
                              description: selectedVendor.description,
                              image: selectedVendor.image_url,
                              name: selectedVendor.category_name,
                              status: selectedVendor.status,
                              subCategory_id: selectedVendor.sub_cat_id,
                              subCategory_name: selectedVendor.name,
                            });
                            console.log("selectedVendor", selectedVendor);
                            setModalOpen(true);
                          }}
                        >
                          Edit
                        </MenuItem>
                        <MenuItem
                          sx={{ display: "none" }}
                          onClick={handleDelete}
                        >
                          Delete
                        </MenuItem>
                      </Menu>
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} style={{ textAlign: "center" }}>
                  No data found for the searched product.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={vendors && vendors.length ? vendors.length : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      {/* Modal */}
      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "calc(100vw - 24px)", sm: 400 },
            maxWidth: "100%",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            maxHeight: "75vh",
            overflowY: "auto",
          }}
        >
          <Typography variant="h6" mb={2}>
            {selectedVendor ? "Edit SubCategory" : "Add SubCategory"}
          </Typography>
         <FormControl fullWidth size="small" sx={{ mb: 2 }}>
  <Select
    labelId="productid-label"
    id="productid"
    name="category"
    value={formValues.category_id}
    onChange={handleInputChange}
    variant="outlined"
    error={!!categoryNameError}  // ✅
  >
    {categories && categories.map((category) => (
      <MenuItem key={category.category_id} value={category.category_id}>
        {category.name}
      </MenuItem>
    ))}
  </Select>
  {categoryNameError && (   // ✅
    <Typography sx={{ textAlign: "left", color: "red", fontSize: 12, mt: 0.5 }}>
      {categoryNameError}
    </Typography>
  )}
</FormControl>

          <TextField
            fullWidth
            label="SubCategory"
            variant="outlined"
            value={formValues.subCategory_name}
            onChange={(e) =>
              setFormValues({ ...formValues, subCategory_name: e.target.value })
            }
            error={!!subCategoryNameError}
            helperText={
              subCategoryNameError && (
                <Typography sx={{ textAlign: "left", color: "red" }}>
                  {subCategoryNameError}
                </Typography>
              )
            }
            sx={{ mb: 2 }}
          />
         <TextField
  fullWidth
  label="Description"
  variant="outlined"
  value={formValues.description}
  onChange={(e) => {
  setFormValues({
    ...formValues,
    description: e.target.value,
  });

  if (e.target.value.trim()) {
    setDescriptionError("");
  }
}}
  error={!!descriptionError}
  helperText={descriptionError}
  sx={{ mb: 2 }}
/>

          {/* Status should be visible only in Edit mode */}
          {selectedVendor && (
            <FormControl fullWidth sx={{ mb: 5 }}>
              <InputLabel>Status</InputLabel>
              <Select
                value={formValues.status == 0 ? 0 : 1} // Default to 1 (Active)
                onChange={(e) => {
                  console.log("select", e.target.value);
                  setFormValues((prev) => ({
                    ...prev,
                    status: e.target.value,
                  }));
                }}
                label="Status"
              >
                <MenuItem value={1}>Active</MenuItem>
                <MenuItem value={0}>Deactive</MenuItem>
              </Select>
            </FormControl>
          )}
         <Input
  type="file"
  fullWidth
  onChange={handleFileChange}
  error={!!imageError}
  sx={{ mb: 1 }}
/>

{imageError && (
  <Typography
    sx={{
      color: "red",
      fontSize: "12px",
      mb: 2,
    }}
  >
    {imageError}
  </Typography>
)}

          {formValues && formValues.image ? (
            <Box
              sx={{
                mb: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                height: formValues.image_url ? "100px" : "auto",
                overflow: "hidden",
              }}
            >
              <img
                src={formValues.image}
                alt="SubCategory"
                style={{
                  // display: "block",
                  // maxWidth: "100%",
                  // maxHeight: 140,
                  // width: "auto",
                  // height: "auto",
                  // objectFit: "contain",
                  maxWidth: "100%",
                  maxHeight: "100px",
                  objectFit: "contain",
                }}
              />
            </Box>
          ) : null}

          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={selectedVendor ? handleEdit : handleAddSubCategory}
          >
            {selectedVendor ? "Update" : "Add"}
          </Button>

          <Button
            variant="outlined"
            color="secondary"
            fullWidth
            onClick={handleCloseModal}
            sx={{ mt: 2 }}
          >
            Close
          </Button>
        </Box>
      </Modal>
    </Box>
  );
}
